export const onMedia = (query = "", styles = {}) => ({
  [`@media (${query})`]: {
    ...styles,
  },
})
export const onSupport = (property = "", styles = {}) => ({
  [`@supports (${property})`]: {
    ...styles,
  },
})
export const flex = (direction = "column") => ({
  display: "flex",
  flexDirection: direction,
})
